import { Box, Button, FormControl, FormLabel, TextField as MuiTextField, Stack } from '@mui/material';
import TextField from '../textField';
import Dropzone, { FileWithPath } from 'react-dropzone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

type Props = {
  label?: string;
  value: string;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  error?: string;
  fullWidth?: boolean;
  isJsonSchema?: boolean;
  rows?: number;
  onChange?: (value: string) => void;
};

const JsonField = ({
  label,
  value,
  required,
  disabled,
  autoFocus,
  error,
  fullWidth = true,
  isJsonSchema = true,
  rows = 2,
  onChange,
}: Props) => {
  const maxFileSize = parseInt(import.meta.env.VITE_MAX_FILE_UPLOAD_SIZE);

  const handleChange = (value: string) => {
    if (onChange) {
      onChange(value);
    }
  };

  const onJsonDrop = async (acceptedFiles: FileWithPath[]) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      const value = await file.text();
      if (onChange) {
        onChange(value);
      }
    }
  };

  return (
    <FormControl variant="standard" fullWidth={fullWidth} sx={{ marginTop: 0 }}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <Stack alignItems={'flex-end'} alignSelf={fullWidth ? 'stretch' : 'flex-start'}>
        <TextField
          value={value ? (typeof value === 'string' ? value : JSON.stringify(value, null, 2)) : ''}
          required
          error={error}
          onChange={handleChange}
          multiline
          rows={rows}
          fullWidth
          disabled={disabled}
          autoFocus={autoFocus}
        />
        <Dropzone onDrop={onJsonDrop} accept={{ 'application/json': ['.json'] }} maxSize={maxFileSize} multiple={false}>
          {({ getRootProps, getInputProps }) => (
            <Box {...getRootProps()}>
              <input {...getInputProps()} />
              <Button
                component="label"
                role={undefined}
                variant="outlined"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                disabled={disabled}
              >
                Upload a JSON {isJsonSchema ? 'Schema' : 'file'}
              </Button>
            </Box>
          )}
        </Dropzone>
      </Stack>
    </FormControl>
  );
};

export default JsonField;
